import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttendanceDetailsComponent } from './components/attendance-details/attendance-details.component';
import { AttendanceService } from './services/attendance.service';
import { NgCircleProgressModule } from 'ng-circle-progress';

@NgModule({
  imports: [
    CommonModule,
    NgCircleProgressModule.forRoot({
      lazy: false
    })
  ],
  declarations: [AttendanceDetailsComponent],
  providers: [AttendanceService]
})
export class AttendanceModule { }
